<template>
  <div class="login-warp" @keyup.enter="submit">
    <div class="container">
      <div class="left">
        <img src="../../assets/img/login-user.png" alt="" />
      </div>
      <div class="right">
        <div class="title">欢迎用户登录！</div>
        <div class="login_content">
          <el-form
            ref="login"
            :model="fromData"
            label-position="left"
            :rules="rules"
          >
            <el-form-item prop="username">
              <el-input
                class="input_item"
                type="text"
                v-model.trim="fromData.username"
                placeholder="请输入用户名称"
                clearable
                maxlength="30"
              >
                <img slot="prefix" class="prefix_icon" :src="iconUser" alt="" />
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="input_item"
                type="password"
                v-model.trim="fromData.password"
                autocomplete="new-password"
                placeholder="请输入密码登录"
                clearable
                show-password
              >
                <img slot="prefix" class="prefix_icon" :src="iconPassword" />
              </el-input>
            </el-form-item>
            <el-form-item prop="phoneNo">
              <el-input
                class="input_item"
                type="text"
                v-model.trim="fromData.phoneNo"
                placeholder="请输入绑定手机号"
                clearable
                maxlength="11"
              >
                <img slot="prefix" class="prefix_icon" :src="iconPhone" />
              </el-input>
            </el-form-item>
          </el-form>
          <el-button class="submit_butto" type="primary" @click="submit()"
            >登录</el-button
          >
        </div>
        <div class="tips">
          <el-checkbox v-model="checked">记住账号</el-checkbox>
          <el-popover placement="bottom" width="185" trigger="hover">
            <div class="popover_content">
              <p>请联系管理员！</p>
              <div class="call_phone">
                <img src="../../assets/img/phone.png" alt="" />
                15800466520
              </div>
            </div>
            <span slot="reference">忘记密码？</span>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    //手机号校验规则
    let validatePhone = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error("请输入手机号"));
      } else {
        let phoneReg = /^[1][0-9]{10}$/;
        if (!phoneReg.test(value)) {
          callback(new Error("请输入11位有效手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      iconUser: require("../../assets/img/icon-user.png"),
      iconPassword: require("../../assets/img/icon-password.png"),
      iconPhone: require("../../assets/img/icon-phone.png"),
      checked: false,
      fromData: {
        username: "",
        password: "",
        phoneNo: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
          },
        ],
        phoneNo: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    const CLOUD_RECORD = localStorage.getItem("CLOUD_RECORD");
    if (CLOUD_RECORD) {
      this.fromData = JSON.parse(CLOUD_RECORD);
      this.checked = true;
    }
  },
  methods: {
    submit() {
      this.$refs["login"].validate((valid) => {
        if (valid) {
          if (this.checked) {
            localStorage.setItem("CLOUD_RECORD", JSON.stringify(this.fromData));
          } else {
            localStorage.setItem("CLOUD_RECORD", "");
          }
          const params = this.fromData;

          // 先选项目再登陆的逻辑
          // const projectId = this.$store.state.user.currentProject.id;
          // this.$Api.loginInfo(params, projectId).then((res) => {
          //   if (res.data) {
          //     this.$store.commit("user/SET_USERINFO", res.data);
          //     this.$router.push("/consult/list");
          //   }
          // });

          // 先登录再选项目的逻辑
          this.$Api.beforeLoginInfo(params).then((res) => {
            if (res.data) {
              this.$store.commit("user/SET_PROJECTS", res.data);
              if (res.data.length == 0) {
                return;
              }
              // 记录用户登录信息
              this.$store.commit("user/SET_LOGIN_FORM", params);
              /**
               * false 该账号只有一个项目直接进入项目页
               * true 该账号有多个项目，需要进入项目选择页
               */
              let projectNumFlag =
                res.data.length > 1 ||
                (res.data.length == 1 && res.data[0].sysProjectDTOS.length > 1);
              console.log("projectNum", projectNumFlag);
              if (projectNumFlag) {
                this.$router.push("/project");
              } else {
                // this.$Api.loginInfo(params, projectId).then((userRes) => {
                //   if (userRes.data) {
                //     this.$store.commit("user/SET_CURRENT_PROJECT", res.data[0]);
                //     this.$store.commit("user/SET_USERINFO", userRes.data);
                //     this.$router.push("/consult/list");
                //   }
                // });
                // let userInfo = JSON.parse(localStorage.getItem("CLOUD_RECORD"));
                let userInfo = JSON.parse(
                  JSON.stringify(this.$store.state.user.loginForm)
                );
                delete userInfo.phoneNo;
                userInfo.projectId = res.data[0].sysProjectDTOS[0].id;
                this.$Api.loginInfo(userInfo).then((userRes) => {
                  if (res.code == 0) {
                    this.$store.commit(
                      "user/SET_CURRENT_PROJECT",
                      res.data[0].sysProjectDTOS[0]
                    );
                    this.$store.commit("user/SET_USERINFO", userRes.data);
                    this.$router.push("/consult/list");
                  }
                });
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-warp {
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/img/login-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    background: #fff;
    border-radius: 20px;
    display: flex;
    justify-content: flex-start;
    .left {
      background: rgba(0, 32, 233, 0.1);
      padding: 100px 0;
      img {
        width: 500px;
      }
    }
    .right {
      width: 500px;
      padding: 66px 100px 0 117px;
      box-sizing: border-box;
      .title {
        font-size: 24px;
        font-weight: 600;
        color: #333333;
      }
      .login_content {
        .input_item {
          margin-top: 40px;
        }
        .el-form-item {
          margin-bottom: 0;
        }
        /deep/ .el-input__inner {
          height: 40px;
          border-radius: 8px;
          border: 1px solid #2846ff;
          padding-left: 40px;
        }
        /deep/.prefix_icon {
          width: 13px;
          padding: 12px 10px;
        }
        .submit_butto {
          width: 100%;
          margin-top: 48px;
        }
      }
      .tips {
        margin-top: 22px;
        display: flex;
        justify-content: space-between;
        /deep/ .el-checkbox__label {
          color: #333333;
        }
        span {
          color: #ff2929;
        }
      }
    }
  }
}
.popover_content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  .call_phone {
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    border-radius: 5px;
    height: 35px;
    margin-top: 12px;
    img {
      width: 12px;
      padding-right: 10px;
    }
  }
}
</style>
